import { graphql, type ResultOf, type VariablesOf } from "../../graphql";

export const GetMediaFilters = graphql(`
  query getMediaFilters($categories: [MediaFilterCategory!]) {
    mediaFilters(categories: $categories) {
      category
      items {
        value
        label
      }
    }
  }
`);

export type MediaFilterCategory = NonNullable<
  ResultOf<typeof GetMediaFilters>["mediaFilters"]
>[number]["category"];

export type UseMediaFilterLabelMapsOptions = {
  categories?: NonNullable<VariablesOf<typeof GetMediaFilters>["categories"]>;
  pause?: boolean;
};
